import lazyLoadOnRender from '../../lazy/loadOnRender';

export type { VivaEngageCollapsiblePanelProps } from './VivaEngageCollapsiblePanel';

const VivaEngageLoadableCollapsiblePanel = () =>
  import(/* webpackChunkName: "4-feat-vivaengagecollapsiblepanel" */ './VivaEngageCollapsiblePanel');

export default lazyLoadOnRender({ loader: VivaEngageLoadableCollapsiblePanel });
